import React from "react"

import { connect } from "scrivito"
import { FileUpload } from "shared/ui/file-upload/FileUpload"

import { useProductPositionFormProductInformationContext } from "../contexts/ProductPositionFormProductInformationContext"

function ProductPositionFormDownloadsTabComponent() {
  const { productInformation, getFilesCallback } =
    useProductPositionFormProductInformationContext()

  if (!productInformation || !getFilesCallback) return null

  const mainFiles = getFilesCallback({
    productType: productInformation.productType
  })
  const addons = productInformation.addons ?? []

  return (
    <div className="product-position-form__tab-content product-position-form__tab-content--downloads">
      {!!mainFiles?.length && (
        <section className="product-position-form__downloads-section">
          <h3 className="product-position-form__tender-text-title">
            {productInformation.title}
          </h3>
          <FileUpload.Root
            className="technical-documentation-list"
            files={mainFiles}
            target="_blank"
            isReadonly
          >
            <FileUpload.List />
          </FileUpload.Root>
        </section>
      )}
      {addons.map(addon => {
        const addonFiles = getFilesCallback({
          productType: addon.productType,
          parentProductType: productInformation.productType
        })
        if (!addonFiles?.length) return null
        return (
          <section
            key={addon.variantKey}
            className="product-position-form__downloads-section"
          >
            <h3 className="product-position-form__tender-text-title">
              {addon.title}
            </h3>
            <FileUpload.Root
              className="technical-documentation-list"
              files={addonFiles}
              target="_blank"
              isReadonly
            >
              <FileUpload.List />
            </FileUpload.Root>
          </section>
        )
      })}
    </div>
  )
}

export const ProductPositionFormDownloadsTab = React.memo(
  connect(ProductPositionFormDownloadsTabComponent)
)
